<template>
  <b-row>
    <b-col md="12">
      <component-header
        title="Delivery Configuration"
        :hasSearch="false"
        :hasReload="false"
        :hasCreate="false"
        :hasback="false"
      />
    </b-col>
    <b-col>
      <b-card>
        <b-row>
          <template>
            <b-col
              md="4"
              v-for="(deleveryItem, index) in deleveryItemList"
              :key="index"
              ><div>
                <b-card
                  style="
                    border-radius: 10px;
                    box-shadow: 0 0 10px 2px rgb(154 161 171 / 15%);
                    min-height: 10rem;
                  "
                >
                  <div class="center">
                    <b-card-img
                      class="card-img-top"
                      :src="deleveryItem.logo"
                      :alt="`${deleveryItem.name} deleveryItem`"
                    />
                    <div></div>
                  </div>
                  <h4 class="text-capitalize">{{ deleveryItem.name }}</h4>
                  <p class="description">
                    {{ deleveryItem.description }}
                  </p>

                  <b-card-footer class="pt-3" style="text-align: center">
                    <button
                      v-if="configuredList[index]"
                      type="button"
                      :id="`gateway-configure-${index}`"
                      style="border-radius: 7px"
                      class="btn btn-success"
                      disabled
                    >
                      Configured
                    </button>
                    <button
                      v-else
                      type="button"
                      style="border-radius: 7px"
                      class="btn btn-primary"
                      @click="onClickConfig(deleveryItem.key)"
                    >
                      <!-- @click="this.$bvModal.show('payment-deleveryItem')" -->
                      Configure
                    </button>
                  </b-card-footer>
                </b-card>
                <b-modal
                  header-class="header-nipige-class"
                  id="payment-deleveryItem"
                  size="sm"
                  ref="payment-deleveryItem-config"
                  centered
                  hide-footer
                >
                  <h3>Modal</h3>
                </b-modal>
              </div>
            </b-col>
          </template>
        </b-row>
      </b-card>
    </b-col>
    <b-modal
      id="modalAdd"
      v-model="dunzoModal"
      centered
      title="Dunzo Configuration"
      header-class="border-0 header-text"
      footer-class="border-0 footer-button"
      modal-class="p-3"
      hide-footer
      ref="field-modal"
    >
      <b-row>
        <b-col md="12" class="pb-2">
          <b-form-input
            placeholder="Enter Client Id"
            v-model="dunzoPayload.clientId"
          ></b-form-input>
        </b-col>
        <b-col md="12" class="pb-2">
          <b-form-input
            placeholder="Enter Token"
            v-model="dunzoPayload.token"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-3 mb-0">
        <b-col md="1"></b-col>
        <b-col md="5">
          <b-button variant="danger" block @click="dunzoModal = false"
            >CANCEL</b-button
          ></b-col
        >
        <b-col md="5">
          <b-button variant="primary" block @click="saveDunzo">SAVE</b-button>
        </b-col>
        <b-col md="1"></b-col>
      </b-row>
    </b-modal>

    <!--shiprocket-->
    <b-modal
      id="modalAdd"
      v-model="shiprocketModal"
      centered
      title="Shiprocket Configuration"
      header-class="border-0 header-text"
      footer-class="border-0 footer-button"
      modal-class="p-3"
      hide-footer
      ref="field-modal"
    >
      <b-row>
        <b-col md="6" class="pb-2">
          <b-form-input
            placeholder="Enter Username"
            v-model="shiprocket.username"
          ></b-form-input>
        </b-col>
        <b-col md="6" class="pb-2">
          <b-form-input
            placeholder="Enter Password"
            v-model="shiprocket.password"
          ></b-form-input>
        </b-col>
        <b-col md="12" class="pb-2">
          <b-form-input
            placeholder="Enter Checksumkey"
            v-model="shiprocket.checksumkey"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-3 mb-0">
        <b-col md="1"></b-col>
        <b-col md="5">
          <b-button
            variant="danger"
            block
            @click="shiprocketModal = false"
            >CANCEL</b-button
          ></b-col
        >
        <b-col md="5">
          <b-button variant="primary" block @click="saveShiprocket"
            >SAVE</b-button
          >
        </b-col>
        <b-col md="1"></b-col>
      </b-row>
    </b-modal>

    <!--Delhivery-->
    <b-modal
      id="modalDelhivery"
      v-model="delhiveryModal"
      centered
      title="Delhivery Configuration"
      header-class="border-0 header-text"
      footer-class="border-0 footer-button"
      modal-class="p-3"
      hide-footer
      ref="field-modal"
    >
      <b-row>
        <b-col md="12" class="pb-2">
          <b-form-input
            placeholder="Enter Username"
            v-model="delhivery.username"
          ></b-form-input>
        </b-col>

        <b-col md="12" class="pb-2">
          <b-form-input
            placeholder="Enter Key"
            v-model="delhivery.key"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-3 mb-0">
        <b-col md="1"></b-col>
        <b-col md="5">
          <b-button
            variant="danger"
            block
            @click="delhiveryModal = false"
            >CANCEL</b-button
          ></b-col
        >
        <b-col md="5">
          <b-button variant="primary" block @click="saveDelhivery"
            >SAVE</b-button
          >
        </b-col>
        <b-col md="1"></b-col>
      </b-row>
    </b-modal>
  </b-row>
</template>
<script>
import profile from "@/components/profile/profileCategory";
import currentUserData from "@/mixins/currentUser";
import { mapState } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  components: {
    profile,
    ComponentHeader,
  },
  mixins: [currentUserData],
  data() {
    return {
      currentUserData: "",
      cashOnDelivery: false,
      onlinePayment: false,
      maxAllowedDevices: "",
      dunzoPayload: {
        clientId: "",
        token: "",
      },
      shiprocket: {
        password: "",
        username: "",
        checksumkey: "",
      },
      delhivery: {
        username: "",
        key: "",
      },
      dunzoModal: false,
      shiprocketModal: false,
      delhiveryModal: false,
      configuredList: [],
    };
  },
  computed: {
    ...mapState({
      deleveryItemList: (state) => state.tenant.deleveryList,
      extendedList: (state) => state.tenant.extendedList,
    }),
  },
  methods: {
    onClickConfig(name) {
      if (name.toLowerCase() === "delhivery") this.delhiveryModal = true;
      if (name.toLowerCase() === "dunzo") this.dunzoModal = true;
      if (name.toLowerCase() === "shiprocket") this.shiprocketModal = true;
    },
    async getDeliveryList() {
      this.$store.dispatch("tenant/setDeleveryItemListData").then(() => {
        this.getConfiguredData();
      });
    },
    getConfiguredData() {
      this.$store.dispatch("tenant/setExtendedAttributeList").then(() => {
        this.configuredList = [];
        for (let temp of this.deleveryItemList) {
          this.configuredList.push(
            this.extendedList[temp.key] == undefined ? false : true
          );
        }
      });
    },
    saveDunzo() {
      this.$store
        .dispatch("tenant/configureDunzoAction", { dunzo: this.dunzoPayload })
        .then(() => {
          this.$swal({
            title: "Success",
            text: "Dunzo Configured Successfully!!",
            type: "success",
          });
          this.getDeliveryList();
          this.dunzoModal = false;
        });
    },
    saveDelhivery() {
      this.$store
        .dispatch("tenant/configureDunzoAction", { delhivery: this.delhivery })
        .then(() => {
          this.$swal({
            title: "Success",
            text: "Delhivery Configured Successfully!!",
            type: "success",
          });
          this.getDeliveryList();
          this.delhiveryModal = false;
        });
    },
    saveShiprocket() {
      this.$store
        .dispatch("tenant/configureDunzoAction", {
          shiprocket: this.shiprocket,
        })
        .then(() => {
          this.$swal({
            title: "Success",
            text: "Shiprocket Configured Successfully!!",
            type: "success",
          });
          this.getDeliveryList();
          this.shiprocketModal = false;
        });
    },
  },
  mounted() {
    this.getDeliveryList();
  },
  created() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>
<style lang="scss">
.language-button button {
  width: 160px;
  margin-bottom: 15px;
  margin-left: 15px;
  margin-right: 15px;
  font-size: 14px;
}
.card-img-top {
  height: 70px;
  width: auto;
  max-width: 100%;
}
.card-body {
  padding: 15px;
}
.card-footer {
  border-top: 2px dashed #c8d1d7;
}
@media (max-width: 768px) {
  .language-button button {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
}
.center {
  text-align: center;
}
.horizontal-line {
  border-top: 1.5px dashed #d8e1e7;
}
.search-container {
  display: block;
  margin: 0 auto;
}

input#search-bar {
  margin: 0 auto;
  width: 80%;
  height: 35px;
  padding: 0 20px;
  font-size: 1rem;
  border: 1px solid #d0cfce;
  outline: none;
  &:focus {
    border: 1px solid #008abf;
    transition: 0.35s ease;
    color: #008abf;
    &::-webkit-input-placeholder {
      transition: opacity 0.45s ease;
      opacity: 0;
    }
    &::-moz-placeholder {
      transition: opacity 0.45s ease;
      opacity: 0;
    }
    &:-ms-placeholder {
      transition: opacity 0.45s ease;
      opacity: 0;
    }
  }
}
.nav-tabs .nav-link.active {
  color: var(--primary);
}
.header-text .modal-title {
  font-size: 1.2rem;
  color: var(--primary);
  text-align: left;
  margin-left: 0;
}
.modal-content {
  padding: 1rem;
}
.description {
  color: black;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4; /* number of lines to show */
  line-clamp: 4;
  min-height: 6rem;
  -webkit-box-orient: vertical;
}
</style>
